module.exports = __webpack_public_path__ + "img/source-sans-pro-v21-latin-regular.eb744643.svg";